import { z } from "zod"

import { refinements, zodResolver } from "./validationScheme"

export const userValidator = {
  password: zodResolver<string>(z.string().min(8).superRefine(refinements.strongPassword)),
  familyName: zodResolver<string>(
    z
      .string()
      .max(8)
      .superRefine(refinements.required)
      .superRefine(refinements.noHalfWidthKatakana)
      .superRefine(refinements.noPlatformDependentChar)
  ),
  firstName: zodResolver<string>(
    z
      .string()
      .max(8)
      .superRefine(refinements.required)
      .superRefine(refinements.noHalfWidthKatakana)
      .superRefine(refinements.noPlatformDependentChar)
  ),
  familyNameKana: zodResolver<string>(
    z.string().max(20).superRefine(refinements.required).superRefine(refinements.onlyFullWidthKatakana)
  ),
  firstNameKana: zodResolver<string>(
    z.string().max(20).superRefine(refinements.required).superRefine(refinements.onlyFullWidthKatakana)
  ),
  corporateName: zodResolver<string>(
    z
      .string()
      .max(25)
      .superRefine(refinements.required)
      .superRefine(refinements.noHalfWidthKatakana)
      .superRefine(refinements.noPlatformDependentChar)
  ),
  corporateNameKana: zodResolver<string>(
    z.string().max(40).superRefine(refinements.required).superRefine(refinements.onlyFullWidthKatakana)
  ),
  departmentName: zodResolver<string>(
    z.string().max(25).superRefine(refinements.noHalfWidthKatakana).superRefine(refinements.noPlatformDependentChar)
  ),
  phoneNumber: zodResolver<string>(
    z
      .string()
      .min(1)
      .max(15)
      .regex(/^([0-9]{2}[0-9,-]{3,}[0-9]{4})*$/, "正しい形式で入力してください。")
  ),
  email: zodResolver<string>(z.string().min(1).email("正しい形式で入力してください。")),
  zipcode: zodResolver<string>(
    z
      .string()
      .regex(/^[0-9]{7}$/, "正しい形式で入力してください。")
      .superRefine(refinements.required)
  ),
  address: zodResolver<string>(
    z.string().max(30).superRefine(refinements.noHalfWidthKatakana).superRefine(refinements.noPlatformDependentChar)
  ),
}
